// extracted by mini-css-extract-plugin
export var preview = "tile-module--preview--f9927";
export var previewArrow = "tile-module--previewArrow--208d2";
export var previewDescription = "tile-module--previewDescription--ef888";
export var previewHeader = "tile-module--previewHeader--c48af";
export var previewImage = "tile-module--previewImage--cb039";
export var previewLink = "tile-module--previewLink--db2dd";
export var previewTall = "tile-module--previewTall--1f0c3";
export var previewTitle = "tile-module--previewTitle--0daae";
export var previewWide = "tile-module--previewWide--8d53c";
export var previewWrapper = "tile-module--previewWrapper--f9e76";